// #region imports

// --- HS Code
import { CommandOfT } from "../shared/command";
import { GroupModel } from "./group-model";

// #endregion

export class UpdateGroupCommand implements CommandOfT<GroupModel[]> {
  private _isExecuted: boolean;

  private _unmodifiedGroup: GroupModel | undefined;
  private readonly _updatedGroup: GroupModel;
  private readonly _groups: GroupModel[];

  get groups(): GroupModel[] {
    if (!this._isExecuted) throw new Error('The command has not yet been executed. No changes have been affected!');
    return this._groups;
  }

  constructor(group: GroupModel, groups: GroupModel[]) {
    this._isExecuted = false;
    this._updatedGroup = group;
    this._groups = groups;
  }

  execute(): GroupModel[] {
    if (this._isExecuted) return this._groups;

    const groupIndex = this._groups.findIndex(g => g.id === this._updatedGroup.id);
    if (groupIndex >= 0) {
      this._unmodifiedGroup = this._groups.splice(groupIndex, 1, this._updatedGroup).at(0);
    }

    this._isExecuted = true;
    return this._groups;
  }

  undo(): GroupModel[] {
    if (!this._isExecuted) return this._groups;

    const groupIndex = this._groups.findIndex(g => g.id === this._updatedGroup.id);
    if (this._unmodifiedGroup && groupIndex >= 0) {
      this._groups.splice(groupIndex, 1, this._unmodifiedGroup).at(0);
    }

    this._isExecuted = false;
    return this._groups;
  }
}
